module.exports = __webpack_public_path__ + "static/media/austin-business-journal.75db00f8.svg";